import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ProductModel } from '../shared/model/product.model';
import { ProductService } from '../shared/service/product.service';
import { MeasureTableService } from '../shared/service/measure-table.service';
import { MessageComponent } from '../shared/component/message/message.component';

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.css']
})
export class ProductComponent implements OnInit {

    @ViewChild(MessageComponent) message: MessageComponent;

    lastEvent: any;
    totalRecords: number;
    searchQuery: string = '';
    measureTableFilter: number = null;

    products: ProductModel[] = [];
    measureTableOptions: any[] = [];
    measureTableMap: Map<number, string> = new Map();

    constructor(
        private productService: ProductService,
        private measureTableService: MeasureTableService,
        private router: Router
    ) { }

    ngOnInit() {
        this.loadMeasureTableOptions();
    }

    loadMeasureTableOptions() {
        this.measureTableService.getPaginated(0, 1000000).subscribe(
            (result: any) => {
                const rows = result['rows'] || [];
                this.measureTableOptions = [{ label: '—', value: null }];
                rows.forEach((t: any) => {
                    const id = t.id || t.measure_table_id;
                    this.measureTableMap.set(id, t.name);
                    this.measureTableOptions.push({ label: t.name, value: id });
                });
            },
            () => {}
        );
    }

    lazy(e) {
        this.lastEvent = e;
        this.productService.getPaginated(e.first, e.rows, this.searchQuery, this.measureTableFilter || undefined).subscribe(
            (result) => {
                this.products = result['rows'] as ProductModel[];
                this.totalRecords = result['count'];
            },
            () => this.message.error()
        );
    }

    search() {
        if (this.lastEvent) {
            this.lastEvent.first = 0;
            this.lazy(this.lastEvent);
        }
    }

    onNew() {
        this.router.navigate(['/product', 'new']);
    }

    onEdit(product: any) {
        if (!product.id) { this.message.error(); return; }
        this.router.navigate(['/product', product.id]);
    }

    onDelete(product: any) {
        if (!product.id) { this.message.error(); return; }
        this.productService.delete(product.id).subscribe(
            () => {
                this.message.success('success_save_message');
                this.lazy(this.lastEvent);
            },
            () => this.message.error()
        );
    }

    getMeasureTableName(id: number): string {
        if (!id) return '—';
        return this.measureTableMap.get(id) || String(id);
    }

    getColor(product: any): string {
        return product && product.other_infos && product.other_infos.color
            ? product.other_infos.color : '';
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/product/product.component.ts